import ImagePanel from './ImagePanel.vue';

export default ImagePanel;
